export const recruitmentstatuses = state => state.getIn(['recruitmentStatuses', 'entities']);
export const recruitmentStatusById = (state, id) => recruitmentstatuses(state).get(String(id));
export const recruitmentStatusesByIds = (state, ids) =>
  ids.map(id => recruitmentStatusById(state, id));
